import React, { useCallback } from 'react';
import cls from 'classnames';

import Select from '@ott/select';
import { l10n } from '@ott/l10n';

import styles from './ServiceClassesDropDown.scss';

const srvClasses = [
  {
    label: l10n('flight.service.economy'),
    value: 'economy',
  },
  {
    label: l10n('flight.service.premiumEconomy'),
    value: 'premium',
  },
  {
    label: l10n('flight.service.business'),
    value: 'business',
  },
  {
    label: l10n('flight.service.first'),
    value: 'first',
  },
];

function ServiceClassesDropDown({ input, isSearchForExchange }) {
  const handleChange = useCallback(
    (value) => {
      input.onChange(value);
    },
    [input.onChange]
  );

  return (
    <Select
      value={input.value}
      onChange={handleChange}
      options={srvClasses}
      alignType="triggerWidth"
      className={cls(styles.ServiceClassesDropDown, {
        [styles.isSearchForExchange]: isSearchForExchange,
      })}
      childrenClassNames={{ trigger: styles.trigger }}
    />
  );
}

export default React.memo(ServiceClassesDropDown);
